import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui';

export function CartFlyoutCloseIcon(props) {
  return (
    <Icon fill="none" height="17px" viewBox="0 0 17 17" width="17px" {...props}>
      <path
        d="M0.75 15.75L15.75 0.75"
        stroke="#1B1A18"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.9"
        strokeWidth="1.5"
      />
      <path
        d="M15.75 15.75L0.75 0.75"
        stroke="#1B1A18"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.9"
        strokeWidth="1.5"
      />
    </Icon>
  );
}

CartFlyoutCloseIcon.displayName = 'CartFlyoutCloseIcon';
